<template>
	<TabWrapper @save="submit" @change="change" @deploy:preview="$emit('deploy:preview')"
							@deploy:live="$emit('deploy:live')">
		<v-container fluid>
			<v-row no-gutters>
				<v-col cols="12" md="5" xl="4" class="pr-md-16">
					<Input :read-only="readOnly" v-model.trim="name" label="Bezeichnung"></Input>
				</v-col>
				<v-col cols="12" md="5" xl="4">
					<Input :disabled="true" v-model.trim="hash" label="Hash"
								 @click:append-outer="snackbar = true"></Input>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" md="5" xl="4" class="pr-md-16">
					<Dropdown :disabled="readOnly" v-model.trim="loading_mode" label="LoadingMode"
										:items="loading_mode_options"></Dropdown>
				</v-col>
				<v-col cols="12" md="5" xl="4">
					<Input :read-only="readOnly" type="number" v-model.trim="content_width"
								 label="Seitenbreite"></Input>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" md="5" xl="4" class="pr-md-16">
					<Dropdown :disabled="readOnly" v-model.trim="webVitalsMode" :items="webVitalsMode_options"
										label="Core Web Vitals Mode"></Dropdown>
				</v-col>
			</v-row>
		</v-container>
		<v-container fluid>
			<v-row class="mb-1 font-weight-bold">
				<v-col>Speicherort</v-col>
			</v-row>

			<v-row no-gutters>
				<v-col cols="12" lg="6">
					<!--  P R E V I E W   P A T H S  -->
					<v-row no-gutters v-for="(path, i) in $store.state.display.relPaths" :key="'preview_'+path">
						<v-col cols="12" class="location_row">
							<div style="width: 80px;">{{ i === 0 ? 'Preview:' : '' }}</div>
							<div class="col2">https://adctrl.emsmobile.de/molten/preview/{{ selectedSite.Name }}/{{
									path
								}}
							</div>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="12" lg="6">
					<!--  L I V E   P A T H S  -->
					<v-row no-gutters v-for="(path, i) in $store.state.display.relPaths" :key="'live_'+path">
						<v-col cols="12" class="location_row">
							<div :style="{width: $vuetify.breakpoint.lgAndUp ? '50px' : '80px'}">
								{{ i === 0 ? 'Live:' : '' }}
							</div>
							<div class="col2">https://adctrl.emsmobile.de/molten/live/{{
									selectedSite.Name
								}}/{{ path }}
							</div>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12" class="location_row">
							<div :style="{width: $vuetify.breakpoint.lgAndUp ? '50px' : '80px'}">
							</div>
							<div class="col2">https://adctrl.emsmobile.de/molten/live/{{
									selectedSite.Name
								}}/MoltenBundle.readable.js
							</div>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-container>
	</TabWrapper>
</template>

<script>
import Input from "../../../components/Inputs/Input";
import TabWrapper from "./TabWrapper";
import Dropdown from "../../../components/Inputs/Dropdown";

export default {
	name: "General",
	components: {Dropdown, TabWrapper, Input},
	props: ['readOnly'],
	data: () => {
		return {
			name: null,
			hash: null,
			loading_mode: null,
			content_width: null,
			webVitalsMode: null,
			inputWidth: '300px',
			loading_mode_options: [
				{text: 'Asynchron', value: 'async'},
				{text: 'Asynchron + Single', value: 'async-sinlge'}
			],
			webVitalsMode_options: [
				{text: 'Deaktiviert', value: 0},
				{text: 'Mode 1', value: 1},
				{text: 'Mode 2', value: 2},
			]
		}
	},
	mounted() {
		this.init();
		this.$emit('activeComponent', this);
	},
	computed: {
		vuexState() {
			return this.$store.state.display;
		},
		siteDetails() {
			return this.vuexState.siteDetails;
		},
		selectedSite() {
			return this.vuexState.selectedSite || '';
		},
		isSmAndDown() {
			return this.$vuetify.breakpoint.smAndDown;
		},
		activeTab() {
			return this.vuexState.activeTab;
		}
	},
	methods: {
		init() {
			if (this.siteDetails) {
				this.name = this.siteDetails.Current.Name;
				this.hash = this.siteDetails.Current.Hash;
				this.loading_mode = this.siteDetails.Current.Loadingmode;
				this.content_width = this.siteDetails.Current.Contentwidth;
				this.webVitalsMode = this.siteDetails.Current.WebVitalsMode;
			}
		},
		submit() {
			this.$emit('submit', this);
		},
		change() {
			if (this.vuexState.previousTab === this.$options._componentTag) {
				this.$emit('change', this);
			} else if (this.activeTab === this.$options._componentTag) {
				this.$emit('activeComponent', this);
			}
		},
		dataChanged() {
			let changed = false;
			if (this.siteDetails && (this.name !== this.siteDetails.Current.Name ||
				this.loading_mode !== this.siteDetails.Current.Loadingmode ||
				this.content_width !== this.siteDetails.Current.Contentwidth ||
				this.webVitalsMode !== this.siteDetails.Current.WebVitalsMode)) {
				changed = true;
			}
			return changed;
		},
		getBody() {
			return {
				publisher_id: this.siteDetails.Site.PublisherId,
				site_id: this.siteDetails.Site.SiteId,
				type_id: this.siteDetails.Current.SitetypeId,
				Name: this.name,
				Hash: this.hash,
				Loadingmode: this.loading_mode,
				contentWidth: this.content_width,
				CoreWebVitals: this.webVitalsMode
			}
		},
	},
	watch: {
		siteDetails() {
			this.init();
		},
		isSmAndDown() {
			if (this.isSmAndDown) {
				this.inputWidth = '100%';
			} else {
				this.inputWidth = '300px';
			}
		}
	}
}
</script>

<style lang="scss" scoped>

.location_row {
	display: flex;
	flex-flow: wrap;

	.col1 {
		width: 80px;
	}
}
</style>